import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { DepartamentsBusinessColor } from '@app/models/departamentsBusinessColor';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class DepartamentsBusinessColorService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get(`${API}departamentBusinessColors`);
  }

  getOne(id) {
    return this.http.get(`${API}departamentBusinessColors/${id}`);
  }

  update(id: any, data: any) {
    return this.http.put(`${API}departamentBusinessColors/${id}`, data);
  }

  delete(id: number) {
    return this.http.put(`${API}departamentBusinessColors/delete/${id}`, {
      id: id
    });
  }
  create(departamentsBusinessColor: DepartamentsBusinessColor) {
    return this.http.post(
      `${API}departamentBusinessColors`,
      departamentsBusinessColor
    );
  }
}
